// Subscription API — отдельный домен от Showcase (см. контракт B 16.06.2026).
// Showcase.status (intro/consent/.../active/locked) и Subscription.state
// (trial/active/cancelled/past_due/none) — независимы. Пересечение нужно
// для UX-нюансов (cancelled-but-paid info-плашка в A3).

import { genRequestId } from '@/lib/requestId'

export type SubscriptionStateValue = 'trial' | 'active' | 'cancelled' | 'past_due' | 'none'

export interface SubscriptionCard {
  brand: string
  lastFour: string
  expiry: string
}

export interface PastDueDetails {
  failedAt?: string
  failureReason?: string
  retryAt?: string
}

export interface Subscription {
  state: SubscriptionStateValue
  plan: string // 'pro' и др.
  currentAmount: number
  subscriptionStartedAt: string
  hasPaymentMethod: boolean
  /** Только при state='cancelled' — оплачено до этой даты, потом доступ снимается. */
  accessEndsAt?: string
  /** Дублирует accessEndsAt — крайний срок для реактивации без перерыва. */
  reactivationDeadline?: string
  /** Для trial. */
  trialEndsAt?: string
  /** Для active. */
  nextChargeDate?: string
  card?: SubscriptionCard
  pastDue?: PastDueDetails
}

class SubscriptionApiError extends Error {
  code: string
  status: number
  requestId: string
  constructor(code: string, status: number, requestId: string, message?: string) {
    super(message || code)
    this.code = code
    this.status = status
    this.requestId = requestId
  }
}

export async function getSubscription(channelUUID: string): Promise<Subscription> {
  const requestId = genRequestId()
  const res = await fetch(
    `/api/max/subscription/${encodeURIComponent(channelUUID)}`,
    {
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'X-Request-Id': requestId,
      },
    },
  )
  if (!res.ok) {
    let body: { error?: string; message?: string } = {}
    try { body = await res.json() } catch {}
    throw new SubscriptionApiError(
      body.error || `HTTP_${res.status}`,
      res.status,
      requestId,
      body.message,
    )
  }
  return res.json()
}

export { SubscriptionApiError }
